import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { UNLINK_IDENTITY_RESOURCE, PRINCIPAL_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UnlinkIdentityService = ComposedComponent =>
  reduxFetch([
    {
      resource: UNLINK_IDENTITY_RESOURCE,
      method: 'delete',
      request: (principalId, identityId, callback, t) => ({
        url: apiRoutes.principalIdentity(principalId, identityId),
        meta: {
          callback,
          principalId,
          identityId,
          setOther: {
            resource: PRINCIPAL_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'unlinkIdentityFailed'),
            onSuccessMessage: t('unlinkIdentitySuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UnlinkIdentityService;
